import styled from 'styled-components'

const AnswerInputGroupUi = styled.div<{ flexBasis?: number }>`
  ${p => p.flexBasis && `flex-basis: ${p.flexBasis}px`}
`

export default AnswerInputGroupUi
